import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Roles } from '@shs-digi-care-monorepo/interfaces';
import { Store } from '@ngxs/store';
import { UsersState } from '../../store/user';

@Injectable({
    providedIn: 'root'
})
export class AdminGuard {
    private store: Store = inject<Store>(Store);
    private router: Router = inject<Router>(Router);

    public async canActivate(): Promise<boolean> {
        const user = this.store.selectSignal(UsersState.getMe());

        if (user()?.roles?.includes(Roles.ADMIN as string)) {
            return true;
        } else {
            void this.router.navigate(['/unauthorized']);
            return false;
        }
    }
}

export const canActivateAdmin: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    adminGuard = inject(AdminGuard)
) => adminGuard.canActivate();
